import { io } from "socket.io-client";

let socket = null;

export const connectSocket = (token) => {
  if (socket?.connected) return socket;

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  socket = io(baseUrl, {
    path: "/chat-socket",
    auth: { token },
    transports: ["websocket", "polling"],
  });

  socket.on("connect", () => {
    console.log("Chat socket connected");
  });

  socket.on("disconnect", () => {
    console.log("Chat socket disconnected");
  });

  socket.on("connect_error", (error) => {
    console.error("Chat socket connection error:", error.message);
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const joinConversation = (conversationId) => {
  if (socket) {
    socket.emit("conversation:join", { conversationId });
  }
};

export const sendSocketMessage = (conversationId, content, messageType = "text", parentMessageId = null) => {
  if (socket) {
    socket.emit("message:send", { conversationId, content, messageType, parentMessageId });
  }
};

export const emitTypingStart = (conversationId) => {
  if (socket) {
    socket.emit("typing:start", { conversationId });
  }
};

export const emitTypingStop = (conversationId) => {
  if (socket) {
    socket.emit("typing:stop", { conversationId });
  }
};

export const emitMessageRead = (conversationId) => {
  if (socket) {
    socket.emit("message:read", { conversationId });
  }
};

export const emitAddReaction = (conversationId, messageId, emoji) => {
  if (socket) {
    socket.emit("reaction:add", { conversationId, messageId, emoji });
  }
};

export const emitRemoveReaction = (conversationId, messageId, emoji) => {
  if (socket) {
    socket.emit("reaction:remove", { conversationId, messageId, emoji });
  }
};

export const emitEditMessage = (conversationId, messageId, content) => {
  if (socket) {
    socket.emit("message:edit", { conversationId, messageId, content });
  }
};

export const emitDeleteMessage = (conversationId, messageId) => {
  if (socket) {
    socket.emit("message:delete", { conversationId, messageId });
  }
};
